import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import OnboardingWalkthrough from '../onboarding/OnboardingWalkthrough';
import ImpersonationBanner from './ImpersonationBanner';
import './Layout.css';

/**
 * Main app layout — only mounts for authenticated (protected) routes.
 * The Login and AuthCallback pages use their own standalone layouts and
 * never render this component, so anything mounted here is automatically
 * excluded from the login flow.
 */
function Layout({ children }) {
  const { user, refreshUser } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);

  // Show onboarding walkthrough if user hasn't completed it
  useEffect(() => {
    if (user && user.has_completed_onboarding === false) {
      setShowOnboarding(true);
    }
  }, [user]);
  // Marker.io bug/feedback tracker.
  // Loaded here (instead of public/index.html) so it's only active on
  // authenticated pages — never on /login or /auth/callback.
  // The snippet self-guards via `if (!window.__Marker)`, so this effect
  // is safe to re-run (e.g., under React StrictMode or route changes).
  useEffect(() => {
    window.markerConfig = {
      project: '69da96bf38c445c82e96f7fc',
      source: 'snippet',
    };

    // Official Marker.io loader snippet, converted to run inside a React effect.
    // Do not edit this block without cross-referencing the Marker.io install docs.
    (function (e, r) {
      if (!e.__Marker) {
        e.__Marker = {};
        const t = [];
        const n = { __cs: t };
        [
          'show', 'hide', 'isVisible', 'capture', 'cancelCapture',
          'unload', 'reload', 'isExtensionInstalled', 'setReporter',
          'clearReporter', 'setCustomData', 'on', 'off',
        ].forEach(function (method) {
          n[method] = function () {
            const args = Array.prototype.slice.call(arguments);
            args.unshift(method);
            t.push(args);
          };
        });
        e.Marker = n;
        const s = r.createElement('script');
        s.async = 1;
        s.src = 'https://edge.marker.io/latest/shim.js';
        const i = r.getElementsByTagName('script')[0];
        i.parentNode.insertBefore(s, i);
      }
    })(window, document);
  }, []);

  const handleOnboardingDismiss = () => {
    setShowOnboarding(false);
    // Refresh user data so has_completed_onboarding is updated in AuthContext
    if (refreshUser) refreshUser();
  };

  return (
    <>
      <ImpersonationBanner />
      <div className="layout">
        <Sidebar />
        <main className="main-content">
          {children}
        </main>
        {showOnboarding && user && (
          <OnboardingWalkthrough user={user} onDismiss={handleOnboardingDismiss} />
        )}
      </div>
    </>
  );
}

export default Layout;
